import 'assets/styles/app.scss';
import { useEffect, useState } from "react";
import { Outlet } from "react-router";
import { useAppSelector } from "app/hooks";
import { AppTranslations, IAppTranslations } from "lib/translations/interfaces/translations.interface";
import AppFooter from "./components/app-footer/app-footer.component";
import ParticipantHeader from "./components/app-header/participant-header/participant-header.component";
import './styles/participant.layout.styles.scss';
import { ToolkitStore } from "@reduxjs/toolkit/dist/configureStore";
import BindServices from "lib/helpers/bind-services";
import en from "assets/prime-locale/en.json";
import enGb from "assets/prime-locale/en-gb.json";
import {addLocale, locale} from "primereact/api";
import {Locale} from "assets/prime-locale/locale.interface";
import "primereact/resources/themes/mira/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import {IGlobal} from "config/config.interface";
import * as Sentry from "@sentry/browser";


export default function ParticipantLayout({ store }: { store: ToolkitStore<any> }) {
    const user = useAppSelector(state => state.user);
    const [translations, setTranslations] = useState({} as IAppTranslations);
    const globalConfig = (global as any as IGlobal);
    BindServices(store as any);

    useEffect(() => {
        if (user.participantLanguageCode) {
            setTranslations(new AppTranslations((window as any).cultures[user.participantLanguageCode]));
            globalConfig.clarity("identify", user.email);
            globalConfig.clarity('set', 'participant-id', user.participantId.toString());
            Sentry.setUser(user as any);
        }
    }, [user]);

    useEffect(() => {
      if(user.participantLanguageCode === 'en-US') {
        addLocale('en', (en as any).en as Locale);
        locale('en');
      } else {
        addLocale('en-gb', (enGb as any)['en-gb'] as Locale);
        locale('en-gb');
      }

    }, [user.participantLanguageCode])

    return (
        <div id="participant-experience">
            <ParticipantHeader translations={translations} />
            <div className="justify-content-center mrg-bg layout-content row no-gutters">
                <Outlet />
            </div>
            <AppFooter />
        </div>
    )
}
